<template>
    <div class="navigation-container">
        <div class="top-navigation">
            <router-link class="route" v-for="(route, idx) in routes" :key="idx" :to="route.path">{{ route.display }}</router-link>
        </div>
        <div class="account-container">
            <button v-if="withLogout" id="bG9nb3V0" class="button passive" @click="emitLogout">
                <label>{{ $t('general.logout') }}</label>
            </button>
        </div>
        <button class="navigation-toggle button passive" @click="showDropdown = !showDropdown">
            <img src="@img/bars.svg"/>
        </button>
        <div v-if="showDropdown" class="dropdown-container" @click="showDropdown = false">
            <router-link class="route" v-for="(route, idx) in routes" :key="idx" :to="route.path">
                <div class="responsive-navigation-link">
                    {{ route.display }}
                </div>
            </router-link>
            <div v-if="withLogout" id="bG9nb3V0" class="responsive-navigation-link" @click="emitLogout">
                {{ $t('general.logout') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "responsive-navigation",
    props: {
        collapseWidth: {
            type: Number,
            default: 792
        },
        withLogout: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDropdown: false
        }
    },
    computed: {
        routes() {
            return this.$router.options.routes
                .filter(route => route.meta.nav)
                .map(route => {
                return {
                    path: route.path,
                    display: this.$t(route.meta.displayKey)
                };
            });
        }
    },
    methods: {
        emitLogout() {
            this.$emit('logout')
        }
    }
}
</script>

<style lang="scss" scoped>
.navigation-container {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    > .top-navigation {
        flex: 1;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        > .route {
            display: block;
            text-decoration: none;
            color: inherit;
            font-size: 2em;
            padding: 8px;
            padding-bottom: 12px;
            margin: 0 16px;

            @media(max-width: 792px) {
                display: none;
            }

            &.router-link-exact-active {
                padding-bottom: 8px;
                border-bottom: 4px solid #162c99;
            }

            &:hover {
                &:not(.router-link-exact-active) {
                    padding-bottom: 8px;
                    border-bottom: 4px solid #162c9966;
                }
            }
        }
    }

    > .account-container {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-bottom: 4px;

        @media(max-width: 792px) {
            display: none;
        }
    }

    > .navigation-toggle {
        margin: auto;

        > img {
            transition: inherit;
            height: 20px;
            width: 20px;
        }

        @media(min-width: 793px) {
            display: none;
        }
    }

    
    > .dropdown-container {
        @media(min-width: 793px) {
            display: none;
        }
        
        position: absolute;
        top: 60px;
        left: 0px;
        right: 0px;
        z-index: 1;

        border-top: 1px solid #ccc;

        .responsive-navigation-link {
            height: 40px;
            padding-left: 20px;
            background: #fff;
            border-bottom: 1px solid #ccc;
            line-height: 40px;
            font-size: 1.5em;
        }

        .route {
            text-decoration: none;
            color: inherit;

            &.router-link-exact-active {
                font-weight: bold;
            }
        }
    }
}
</style>